import React, { useContext, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import UserAvatar from '../../../../components/user-avatar';
import { View } from '../../types';
import { User } from '../../../../types';
import { VIEWS } from '../sidebar-mobile/constants';

import * as S from './styles';

type Props = {
  visible?: boolean;
  isAuthenticated?: boolean;
  me: User;
  onLinkClick?: () => void;
  onOpenView: (view: View) => void;
};

const UserMenu = ({
  visible,
  isAuthenticated,
  me,
  onLinkClick,
  onOpenView,
}: Props) => {
  const { t } = useContext(AppContext);
  const onOpenLists = useCallback(() => onOpenView(VIEWS.LISTS), [onOpenView]);
  const onOpenAlerts = useCallback(() => onOpenView(VIEWS.ALERTS), [
    onOpenView,
  ]);
  const onOpenUserMenu = useCallback(() => onOpenView(VIEWS.USER), [
    onOpenView,
  ]);

  return (
    <S.UserMenu visible={visible}>
      <S.UserMenuList>
        {isAuthenticated ? (
          <S.UserMenuItem
            name={me.displayName || me.email}
            image={
              <UserAvatar
                avatar={me.avatar}
                displayName={me.displayName}
                email={me.email}
                styling="blue"
                size={40}
              />
            }
            onClick={onOpenUserMenu}
          />
        ) : (
          <S.LoginButtonWrapper>
            <S.LoginButton
              color="primary"
              onClick={onLinkClick}
              component={<Link to="/login" />}
            >
              {t('account', 'menu.not-logged-in-button')}
            </S.LoginButton>
          </S.LoginButtonWrapper>
        )}

        <S.UserMenuItem
          name={t('account', 'menu.lists')}
          image={<S.ListsIcon />}
          onClick={onOpenLists}
        />

        <S.UserMenuItem
          name={t('account', 'menu.alerts')}
          image={<S.AlertsIcon />}
          onClick={onOpenAlerts}
        />
      </S.UserMenuList>
    </S.UserMenu>
  );
};

export default UserMenu;
